import { useTranslation } from 'react-i18next';

/**
 * Shown for the moment between detecting a stale chunk and the replacement
 * document loading (SP-1330). Deliberately minimal - it is on screen briefly.
 */
export const UpdatingNotice = () => {
  const { t } = useTranslation('routeError');

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-col items-center justify-center h-screen gap-4"
    >
      <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent"></div>
      <p className="text-lg font-medium text-gray-700 dark:text-gray-200">
        {t('updating')}
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        {t('updatingMessage')}
      </p>
    </div>
  );
};
